const CDN_URL = new URL(process.env.VUE_APP_CDN_URL).origin

export const parseUrl = (name: string, size: string = "full"): string => {
  return name.slice(0, 16).split("").join("/") + "/" + size + "/" + name
}

export const getFullImagePath = (name: string, size: string = "full"): string => {
  return `${CDN_URL}/media/assets/images/${parseUrl(name, size)}`
}

export const getFullVideoPath = (name: string, size: string = "full"): any => {
  return `${CDN_URL}/media/assets/videos/${parseUrl(name, size)}`
}
